import * as React from "react";

function SvgBag(props) {
  return (
    <svg height="1em" viewBox="0 0 480 480" width="1em" {...props}>
      <path stroke="black" strokeWidth="10" d="M372.052 480H107.948c-23.46 0-41.906-20.152-39.845-43.516l24.353-276C94.291 139.685 111.42 124 132.301 124H157V83c0-45.767 37.233-83 83-83s83 37.233 83 83v41h24.699a8 8 0 010 16H323v36a8 8 0 01-16 0v-36H202a8 8 0 010-16h105V83c0-36.944-30.056-67-67-67s-67 30.056-67 67v93a8 8 0 01-16 0v-36h-24.699c-12.528 0-22.806 9.411-23.907 21.891l-24.353 276C82.8 451.953 93.848 464 107.948 464h264.104c14.117 0 25.147-12.064 23.907-26.109l-24.353-276a8 8 0 0115.938-1.406l24.353 276c2.062 23.369-16.39 43.515-39.845 43.515zM194 411h-58a8 8 0 000 16h58a8 8 0 000-16zm0-40h-58a8 8 0 000 16h58a8 8 0 000-16z" />
    </svg>
  );
}

export default SvgBag;